<!-- ******************************* -->
<!--            LOGIN FORM           -->
<!-- ******************************* -->
<div *ngIf="isCheckedToken" class="parent">
  <div class="fullHeight">
    <div class="loginCard">

      <!-- ******************************* -->
      <!--              LOGO               -->
      <!-- ******************************* -->
      <img *ngIf="!appService.isDarkTheme"
           alt="ketonlogo"
           class="loginLogo centeredElement"
           src="assets/KetonLogo.png"/>
      <img
        *ngIf="appService.isDarkTheme"
        alt="ketonlogo"
        class="loginLogo centeredElement"
        src="assets/KetonLogo_white.png"/>

      <div [style.max-width.px]="(isMobile) ? 300 : 400" [style.min-width.px]="(isMobile) ? 250 : 335"
           class="loginFormContainer">

        <div class="loginForm">

          <dx-form #loginForm (onEditorEnterKey)="editorEnterKey($event)" [colCount]="1" [disabled]="isLoggingIn"
                   [formData]="loginUser" id="form"
                   labelMode="outside"
                   style="width: 100%">
            <dxi-item dataField="username">
              <dxi-validation-rule
                message="{{'LOGIN.USERNAME_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
                type="required">
              </dxi-validation-rule>
              <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                   [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                   type="stringLength"></dxi-validation-rule>
              <dxo-label [text]="'LOGIN.USERNAME' | translate"></dxo-label>

            </dxi-item>

            <dxi-item [editorOptions]="passwordEditorOptions" dataField="password" editorType="dxTextBox"
                      name="password">
              <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                   [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                   type="stringLength"></dxi-validation-rule>
              <dxi-validation-rule
                message="{{'LOGIN.PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
                type="required">
              </dxi-validation-rule>
              <dxo-label [text]="'LOGIN.PASSWORD' | translate"></dxo-label>
            </dxi-item>
          </dx-form>
          <div
            style="display: flex;
            flex-direction: row;
            gap: 20px;
            width: 100%;
            padding: 8px 0;
            justify-content: space-between">

            <div style="
            flex: 1 1;
            display: flex;
              justify-content: flex-start;
              align-items: center;">
              <span style="margin-right:10px">{{ 'LOGIN.REMEMBER_ME' | translate }}</span>
              <dx-switch [(value)]="loginUser.rememberMeFlag"
                         [disabled]="isLoggingIn">
              </dx-switch>

            </div>
            <div *ngIf="!isLoggingIn" style="
            flex: 1 1;
            display: flex;
              justify-content: flex-end;
              align-items: center;">
              <span (click)="resetPasswordStart()" class="clickableText"
                    style="margin-right:10px"><i>{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</i></span>
            </div>

          </div>
          <div
            style="display: flex;
            flex-direction: row;
            gap: 20px;
            width: 100%;
            padding: 8px 0;
            justify-content: space-between">

            <dx-button (click)="awaitLogin()" [disabled]="isLoggingIn" [elementAttr]="primaryButtonAttributes"
                       [height]="40"
                       [text]="'LOGIN.LOG_IN' | translate " [type]="'default'" [width]="'100%'"
                       style="flex: 1 1;">
            </dx-button>

          </div>
        </div>
      </div>
    </div>

    <!-- ******************************* -->
    <!--      POWERED BY INDICATION      -->
    <!-- ******************************* -->
    <div class="centerFooter">
      <span><em>Powered by  </em></span>
      <a href="https://www.inntea.it/" rel="noopener" target="_blank" title="Inntea">
        <img *ngIf="appService.isDarkTheme"
             alt="innteaLogoDark"
             class="orizImg"
             height="21" ngSrc="../../../assets/INNTEA_logo_ORIZ_white.svg" width="76"/>
        <img *ngIf="!appService.isDarkTheme"
             alt="innteaLogoLight"
             class="orizImg"
             height="21" ngSrc="../../../assets/INNTEA_logo_ORIZ.svg" width="76"/>
      </a>
      -
      <a class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
         href="{{appService.IUBENDA_PRIVACY_POLICY_LINK}}"
         target="_blank" title="Privacy Policy ">Privacy
        Policy</a>
      <script type="text/javascript">(function (w, d) {
        var loader = function () {
          var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0];
          s.src = "https://cdn.iubenda.com/iubenda.js";
          tag.parentNode.insertBefore(s, tag);
        };
        if (w.addEventListener) {
          w.addEventListener("load", loader, false);
        } else if (w.attachEvent) {
          w.attachEvent("onload", loader);
        } else {
          w.onload = loader;
        }
      })(window, document);</script>
    </div>

    <!-- ******************************* -->
    <!--     ENVIRONMENT INDICATION      -->
    <!-- ******************************* -->
    <div class="rightTop">
      <h3 *ngIf="printEnvironments() !== 'prod'" class="envType">Environment: {{ printEnvironments() }}</h3>
    </div>
  </div>

</div>
<!--<dx-toast [(visible)]="toastService.messageVisible" [closeOnClick]="true"-->
<!--          [displayTime]="toastService.messageDisplayTime"-->
<!--          [hideOnOutsideClick]="false"-->
<!--          [message]="toastService.messageText"-->
<!--          [type]="toastService.getMessageType()"-->
<!--          [width]="500">-->
<!--</dx-toast>-->

<app-forgot-password #forgotPassword (closeDialog)="doResetPasswordRequest($event)"
                     *ngIf="forgotPasswordPopupOpen">
</app-forgot-password>
